import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { PiSunglassesBold } from "react-icons/pi";
import { IoMdAppstore } from "react-icons/io";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
} from "../../store/actions";
import withRouter from "../Common/withRouter";
import socketIO from "socket.io-client";
import SDK from "../../config";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathName: this.props.router.location.pathname,
      openDropdown: null,
      totalUnread: 0,
      isAndroidMenuOpen: false,
      isiOSMenuOpen: false,
    };
  }

  componentDidMount() {
    this.initMenu();
    this.socket = socketIO(SDK.SOCKET_URL);

    this.socket.emit("ios-total-unread-chat-rooms");

    this.socket.on("ios-total-unread-chat-rooms-response", (count) => {
      this.setState({ totalUnread: count });
    });
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.off("ios-total-unread-chat-rooms-response");
      this.socket.disconnect();
    }
  }

  UNSAFE_componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.type !== prevProps.type) {
        this.initMenu();
      }
    }
    if (
      this.props.router.location.pathname !== prevProps.router.location.pathname
    ) {
      this.setState({ pathName: this.props.router.location.pathname }, () => {
        this.initMenu();
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  initMenu() {}

  handleMenuClick = (path) => {
    this.setState({ pathName: path });
  };

  handleDropdownToggle = (index) => {
    this.setState((prevState) => ({
      openDropdown: prevState.openDropdown === index ? null : index,
    }));
  };

  toggleAndroidMenu = () => {
    this.setState((prevState) => ({
      isAndroidMenuOpen: !prevState.isAndroidMenuOpen,
      isiOSMenuOpen: false,
      isGlassesMenuOpen: false,
    }));
  };

  toggleIOSMenu = () => {
    this.setState((prevState) => ({
      isiOSMenuOpen: !prevState.isiOSMenuOpen,
      isAndroidMenuOpen: false,
      isGlassesMenuOpen: false,
    }));
  };

  toggleGlassesMenu = () => {
    this.setState((prevState) => ({
      isGlassesMenuOpen: !prevState.isGlassesMenuOpen,
      isAndroidMenuOpen: false,
      isiOSMenuOpen: false,
    }));
  };

  render() {
    const { t } = this.props;
    const {
      openDropdown,
      pathName,
      totalUnread,
      isAndroidMenuOpen,
      isiOSMenuOpen,
      isGlassesMenuOpen,
    } = this.state;

    return (
      <React.Fragment>
        <style>
          {`
            #sidebar-menu .menu_active{
             color: #007bff !important;
            }
        #sidebar-menu .active > a {
          color: #007bff !important;
          border-radius: 5px; /* Optional: adds rounded corners */
        }
        #sidebar-menu .waves-effect {
          transition: background-color 0.3s ease;
        }
        #sidebar-menu .has-arrow1 i {
          margin-left: auto;
          transform: rotate(0deg);
          transition: transform 0.3s ease;
        }
        #sidebar-menu .has-arrow1.open i {
          transform: rotate(180deg);
        }
        #sidebar-menu .sub-menu {
          display: none;
          padding-left: 14px;
          padding-right: 0px !important;
        }
        #sidebar-menu .sub-menu.open {
          display: block;
        }
        #sidebar-menu .menu-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          padding-right: 14px;
          color: #74788d; /* Default text and icon color */
          height: 50px; /* Ensure equal height for all menu items */
          transition: background-color 0.3s ease, color 0.3s ease;
        }
        #sidebar-menu .menu-item:hover span,
        #sidebar-menu .menu-item.active {
          color: #007bff; /* Active text and icon color */
        }
        #sidebar-menu .menu-item:hover,
        #sidebar-menu .menu-item.active {
          color: #007bff; /* Active text and icon color */
          background-color: rgba(0, 123, 255, 0.1); /* Light background color on hover/active */
          width: 100%; /* Ensure the full width is covered */
          height: 50px; /* Consistent height with the menu item */
        }
        #sidebar-menu .menu-item:hover i,
        #sidebar-menu .menu-item.active i {
          color: #007bff; /* Ensure icon color also changes on active state */
        }
        #sidebar-menu .menu-item i {
          margin-right: 10px;
          transition: color 0.3s ease; /* Smooth transition for icon color */
        }
        #sidebar-menu .sub-menu .menu-item {
          height: 45px; /* Ensure sub-menu items have a slightly smaller height */
        }
        #sidebar-menu .sub-menu .menu-item:hover,
        #sidebar-menu .sub-menu .menu-item.active {
          background-color: rgba(0, 123, 255, 0.1); /* Ensure sub-menu item has the same hover effect */
          color: #007bff; /* Sub-menu item text color change on hover/active */
          border-radius: 5px;
          width: 100%;
          height: 45px; /* Consistent height for sub-menu items */
        }
      `}
        </style>

        <div id="sidebar-menu">
          <ul className="list-unstyled">
            <li className="menu-title">{t("Menu")}</li>

            <li
              className={`menu-item ${
                pathName === "/dashboard" ? "active" : ""
              }`}
            >
              <Link
                to="/dashboard"
                className="waves-effect"
                onClick={() => this.handleMenuClick("/dashboard")}
              >
                <i className="ri-dashboard-line"></i>
                <span className="ms-1">{t("Dashboard")}</span>
              </Link>
            </li>

            {/* Android Menu */}
            <li
              className={` menu-item has-arrow1 waves-effect ${
                isAndroidMenuOpen ? "open " : ""
              } ${
                pathName === "/devices" ||
                pathName === "/payment" ||
                pathName === "/view_lifeTime_email" ||
                pathName === "/uninstallSurvey" ||
                pathName === "/paymentIssue"
                  ? "menu_active"
                  : ""
              }`}
              onClick={this.toggleAndroidMenu}
            >
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ marginLeft: "25px" }}
              >
                <div>
                  <i
                    className="ri-android-line pt-2"
                    style={{ fontSize: "1rem" }}
                  ></i>
                </div>
                <div style={{ marginLeft: "10px", fontWeight: "bold" }}>
                  {t("Android")}
                </div>
              </div>
              <i className="ri-arrow-down-s-line pt-1"></i>
            </li>
            <ul className={`sub-menu ${isAndroidMenuOpen ? "open" : ""}`}>
              <li
                className={`menu-item ${
                  pathName === "/devices" ? "active" : ""
                }`}
              >
                <Link
                  to="/devices"
                  className="waves-effect"
                  onClick={() => this.handleMenuClick("/devices")}
                >
                  <i className="ri-device-line"></i>
                  <span className="ms-1">{t("Devices")}</span>
                </Link>
              </li>

              <li
                className={`menu-item ${
                  pathName === "/payment" ? "active" : ""
                }`}
              >
                <Link
                  to="/payment"
                  className="waves-effect"
                  onClick={() => this.handleMenuClick("/payment")}
                >
                  <i className="ri-exchange-dollar-line"></i>
                  <span className="ms-1">{t("Payment")}</span>
                </Link>
              </li>
              <li
                className={`menu-item ${
                  pathName === "/view_lifeTime_email" ? "active" : ""
                }`}
              >
                <Link
                  to="/view_lifeTime_email"
                  className="waves-effect"
                  onClick={() => this.handleMenuClick("/view_lifeTime_email")}
                >
                  <i className="ri-user-star-line"></i>
                  <span className="ms-1">{t("Beta Subscriber")}</span>
                </Link>
              </li>

              <li
                className={`menu-item ${
                  pathName === "/uninstallSurvey" ? "active" : ""
                }`}
              >
                <Link
                  to="/uninstallSurvey"
                  className="waves-effect"
                  onClick={() => this.handleMenuClick("/uninstallSurvey")}
                >
                  <i className="ri-shield-user-line"></i>
                  <span className="ms-1">{t("Uninstall Survey")}</span>
                </Link>
              </li>

              <li
                className={`menu-item ${
                  pathName === "/paymentIssue" ? "active" : ""
                }`}
              >
                <Link
                  to="/paymentIssue"
                  className="waves-effect"
                  onClick={() => this.handleMenuClick("/paymentIssue")}
                >
                  <i className="ri-error-warning-line"></i>
                  <span className="ms-1">{t("Payment Issues")}</span>
                </Link>
              </li>
            </ul>

            {/* iOS Menu */}
            <li
              className={` menu-item has-arrow1 waves-effect ${
                isiOSMenuOpen ? "open" : ""
              } ${
                pathName === "/addNewApp" ||
                pathName === "/chat" ||
                pathName === "/iOS-missing-app" ||
                pathName === "/ios-subscriptions" ||
                pathName === "/iosBetaSubscriber"
                  ? "menu_active"
                  : ""
              }`}
              onClick={this.toggleIOSMenu}
            >
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ marginLeft: "25px" }}
              >
                <div>
                  <i
                    className="ri-apple-line pt-2"
                    style={{ fontSize: "1rem" }}
                  ></i>
                </div>
                <div style={{ marginLeft: "10px", fontWeight: "bold" }}>
                  {t("iOS")}
                </div>
              </div>
              <i className="ri-arrow-down-s-line pt-1"></i>
            </li>
            <ul className={`sub-menu ${isiOSMenuOpen ? "open" : ""}`}>
              <li
                className={`menu-item ${
                  pathName === "/addNewApp" ? "active" : ""
                }`}
              >
                <Link
                  to="/addNewApp"
                  className="waves-effect"
                  onClick={() => this.handleMenuClick("/addNewApp")}
                >
                  <i className="ri-app-store-line"></i>
                  <span className="ms-1">{t("Add Resolve App")}</span>
                </Link>
              </li>

              <li
                className={`menu-item ${pathName === "/chat" ? "active" : ""}`}
              >
                <Link
                  to="/chat"
                  className="waves-effect"
                  onClick={() => this.handleMenuClick("/chat")}
                >
                  <i className="ri-chat-1-line"></i>
                  <span className="ms-1">{t("iOS Chat")}</span>
                </Link>
                <div
                  className="badge rounded-pill bg-success me-2"
                  style={{ fontWeight: "600" }}
                >
                  {totalUnread && totalUnread.count}
                </div>
              </li>

              <li
                className={`menu-item ${
                  pathName === "/iOS-missing-app" ? "active" : ""
                }`}
              >
                <Link
                  to="/iOS-missing-app"
                  className="waves-effect"
                  onClick={() => this.handleMenuClick("/iOS-missing-app")}
                >
                  <i className="ri-apps-2-fill"></i>
                  <span className="ms-1">{t("Missing Apps")}</span>
                </Link>
              </li>
              <li
                className={`menu-item ${
                  pathName === "/ios-subscriptions" ? "active" : ""
                }`}
              >
                <Link
                  to="/ios-subscriptions"
                  className="waves-effect"
                  onClick={() => this.handleMenuClick("/ios-subscriptions")}
                >
                  <i className="ri-apps-2-fill"></i>
                  <span className="ms-1">{t("Subscriptions")}</span>
                </Link>
              </li>

              <li
                className={`menu-item ${
                  pathName === "/iosBetaSubscriber" ? "active" : ""
                }`}
              >
                <Link
                  to="/iosBetaSubscriber"
                  className="waves-effect"
                  onClick={() => this.handleMenuClick("/iosBetaSubscriber")}
                >
                  <i className="ri-user-star-line"></i>
                  <span className="ms-1">{t("Beta Subscriber")}</span>
                </Link>
              </li>

              <ul
                className={`sub-menu ${
                  openDropdown === 0 ? "open menu_active" : ""
                }`}
              >
                <li
                  className={`menu-item  ${
                    pathName === "/chat" ? "active" : ""
                  }`}
                >
                  <Link
                    className="w-100"
                    to="/chat"
                    onClick={() => this.handleMenuClick("/chat")}
                  >
                    <div className=" d-flex justify-content-between">
                      <div>{t("iOS Chat")}</div>
                      <div
                        className="badge rounded-pill bg-success"
                        style={{ fontWeight: "600" }}
                      >
                        {totalUnread && totalUnread.count}
                      </div>
                    </div>
                  </Link>
                </li>
              </ul>
            </ul>

            {/* Glasses Menu */}
            <li
              className={`menu-item has-arrow1 waves-effect ${
                isGlassesMenuOpen ? "open" : ""
              }
                 ${pathName === "/glassesApk" ? "menu_active" : ""}
                `}
              onClick={this.toggleGlassesMenu}
            >
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ marginLeft: "25px" }}
              >
                <div>
                  <PiSunglassesBold style={{ fontSize: "1rem" }} />
                </div>
                <div style={{ marginLeft: "18px", fontWeight: "bold" }}>
                  {t("Glasses")}
                </div>
              </div>
              <i className="ri-arrow-down-s-line pt-1"></i>
            </li>
            <ul className={`sub-menu ${isGlassesMenuOpen ? "open" : ""}`}>
              <li
                className={`menu-item ${
                  pathName === "/glassesApk" ? "active" : ""
                }`}
              >
                <Link
                  to="/glassesApk"
                  className="waves-effect"
                  onClick={() => this.handleMenuClick("/glassesApk")}
                >
                  <i>
                    <IoMdAppstore style={{ marginTop: "-5px" }} />
                  </i>
                  <span className="ms-1 ">{t("Upload Apk")}</span>
                </Link>
              </li>
            </ul>

            <li
              className={`menu-item ${
                pathName === "/viewEmails" ? "active" : ""
              }`}
            >
              <Link
                to="/viewEmails"
                className="waves-effect"
                onClick={() => this.handleMenuClick("/viewEmails")}
              >
                <i className="ri-mail-check-line"></i>
                <span className="ms-1">{t("Get In Touch")}</span>
              </Link>
            </li>

            <li className="menu-title">{t("Components")}</li>
            <li
              className={`menu-item has-arrow1 waves-effect ${
                openDropdown === 1 ? "open" : ""
              } ${pathName.includes("/auth") ? "active" : ""}`}
              onClick={() => this.handleDropdownToggle(1)}
            >
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ marginLeft: "25px" }}
              >
                <div>
                  <i
                    className="ri-account-circle-line pt-2"
                    style={{ fontSize: "1.1rem" }}
                  ></i>
                </div>
                <div style={{ marginLeft: "10px" }}>{t("Authentication")}</div>
              </div>
              <i className="ri-arrow-down-s-line pt-1"></i>
            </li>
            <ul className={`sub-menu ${openDropdown === 1 ? "open" : ""}`}>
              <li
                className={`menu-item ms-4 ${
                  pathName === "/devices" ? "active" : ""
                }`}
              >
                <Link
                  className="w-100"
                  to="/devices"
                  onClick={() => this.handleMenuClick("/devices")}
                >
                  <div className=" d-flex justify-content-between">
                    <div>{t("Update Password")}</div>
                  </div>
                </Link>
              </li>
            </ul>
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout.layout,
    layoutWidth: state.Layout.layoutWidth,
    sidebarType: state.Layout.sidebarType,
    sidebarTheme: state.Layout.sidebarTheme,
    preloader: state.Layout.preloader,
  };
};

export default connect(mapStateToProps, {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
})(withRouter(withTranslation()(SidebarContent)));
